module.exports = __webpack_public_path__ + "img/slide4.195bc869.png";